export const FECHAS_TEST_DRIVE = [
  { value: "27-06", label: "27 de Junio" },
];

export const SUCURSALES_RANGER = [
  {
    value: "cba",
    label: "Córdoba Capital",
    subtitulo: "Salón de Ventas",
    direccion: "Av. Emilio Caraffa 1842",
  },
  {
    value: "rio-cuarto",
    label: "Río Cuarto",
    direccion: "Lateral A005, Complejo Mercomax, Local 2",
  },
  {
    value: "villa-maria",
    label: "Villa María",
    direccion: "Av. Perón 2691",
  },
];

export const getFechaLabel = (value) => FECHAS_TEST_DRIVE.find((f) => f.value === value)?.label || value;

export const getSucursal = (value) => SUCURSALES_RANGER.find((s) => s.value === value);

export const getSucursalOptionLabel = (sucursal) => {
  const partes = [sucursal.label];
  if (sucursal.subtitulo) partes.push(sucursal.subtitulo);
  return `${partes.join(" — ")} · ${sucursal.direccion}`;
};
